
import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { CLIENT, CACHE_STRATEGY } from '@/constants';
import { CLoader } from '@/components/loader'
import { CButton } from '@/components/form-controls/button'
import { PreloadService, LanguagesService } from '@/@next/services'
import CModal from '@/components/modal'
import { Language } from '@/@types/graphql'
import { messages } from '@/@next/i18n'
import { SvgIcon, IconDownload} from '@/@next/components/icons'

const config = {
  name: 'l-default-cache-preloader',
  i18n: { messages },
  components: {
    CLoader,
    CButton,
    ...CModal,
    SvgIcon,
    IconDownload
  }
}

@Component(config)
export default class LDefaultCachePreloader extends Mixins(PreloadService, LanguagesService) {

  isOpen: boolean = true
  showPreloadModal: boolean = false
  showReloadModal: boolean = false
  willReload: boolean = false;
  // hasAcceptPreload: boolean = false;

  @Watch('preloadDataset')
  @Watch('appIsReady')
  @Watch('serviceWorkerIsReady')
  onCachePreloaderStateUpdate () {
    console.log(`[temp] onCachePreloaderStateUpdate. 
      (preloadDataset: ${this.preloadDataset},
      appIsReady: ${this.appIsReady},
      preloadIsEnabled: ${this.preloadIsEnabled})`)
    if (!this.preloadDataset || !this.appIsReady || !this.preloadIsEnabled) return
    console.log(`[temp] Service Worker is ready ?: ${this.serviceWorkerIsReady}`)
    if (!this.serviceWorkerIsReady) return this.tryToReload()
    // block reloading function
    this.willReload = false
    if (!this.acceptPreload)
      setTimeout(() => this.showPreloadModal = true, this.preloadDataset?.configuration?.timeout || 2000)
  }

  @Watch('preloadEnded')
  onPreloadEndedUpdate () {
      this.setDisplayPreloadStatus(true)
      if (this.preloadSuccess) setTimeout(() => this.setDisplayPreloadStatus(false), 2000)
  }

  @Watch('displayPreloadStatus')
  onDisplayPreloadStatusUpdate () {
    if (this.displayPreloadStatus) this.isOpen = true
  }

  @Watch('needToReloadApp')
  onNeedToReloadAppUpdate () {
    console.log('Need to reload app', this.needToReloadApp)
    if (this.needToReloadApp) this.showReloadModal = true
  }

  onAcceptPreload () {
    this.setAcceptPreload(true)
    this.showPreloadModal = false
    this.startPreloadingData()
  }

  async mounted () {
    console.info(`[Info][CachePreloader] Cache stratery for project ${CLIENT} : ${CACHE_STRATEGY}`)
    await this.fetchPreloadDataset()
    this.onNeedToReloadAppUpdate()
  }

  tryToReload () {
    console.info('[Info][CachePreloader] Reloading app')
    console.log('SAFARI ? ', this.isSafari)
    if (this.willReload) return

    // To Do test Firefox
    // if (this.isSafari) {
    console.log('[temp] Safari reload')
    this.willReload = true;
    // this.showReloadModal = true;
    setTimeout(() => this.showReloadModal = true, 2000) // TODO : alert User
    // }
  }

  cancelReload () {
    this.showReloadModal = false;
    this.willReload = false;
    this.setNeedToReloadApp(false)
  }

  accepReload () {
    this.showReloadModal = false
    this.setNeedToReloadApp(false)
    setTimeout(() => location.reload(), 1000)
  }

  reloadApp () {
      console.log('[temp] in reloading app function')
      if (!this.willReload) return
      location.reload()
  }

  get isSafari () {
      const  ua = navigator.userAgent.toLowerCase(); 
      let isSafari = false;
      try {
          // @ts-ignore
          isSafari = /constructor/i.test(window.HTMLElement) || ((p: any) => p.toString() === '[object SafariRemoteNotification]')(!window.safari || safari.pushNotification);
      } catch (err) { console.error(err)}
      isSafari = (isSafari || ((ua.indexOf('safari') !== -1)
          && (!(ua.indexOf('chrome') !== -1) && (ua.indexOf('version/') !== -1))));
      return isSafari
  }

  get forcePreload () {
    return this.preloadDataset?.configuration?.forcePreload
  }

  get blockUser () {
    return this.showPreloadModal || (this.forcePreload && this.acceptPreload && !this.preloadEnded)
  }

  get CSSClasses () {
    return {
      'is-Open': this.displayPreloadStatus || this.blockUser, // && !this.preloadEnded,
      'overlay': this.blockUser 
      // this.forceOpenthis.forcePreload && (this.showPreloadModal || (this.hasAcceptPreload && !this.preloadEnded))
    }
  }

  get currentLanguageName () {
    const language = this._allLanguages.find((l: Language) => l.iso === this._currentLanguage)
    if (!language) return this._currentLanguage
    return language.name
  }

}
